// Monstros especiais das hunts: Super (bronze), Mega (prata) e Ultra (dourado).
// Qualquer monstro de qualquer respawn pode nascer assim. São pacíficos até alguém atacar
// e somem depois de 2 minutos sem levar ataque (o respawn recomeça como se tivessem morrido).

export type EliteTier = 1 | 2 | 3;
export type EliteKey = 'super' | 'mega' | 'ultra';

export interface EliteDef {
  key: EliteKey; prefix: string;
  /** multiplicador da vida (o único status multiplicado) */
  stats: number;
  xp: number; gold: number; drops: number;
  /** chance de nascer assim a cada respawn (proposta, ajustável) */
  chance: number;
  color: number;
}

export const ELITE: Record<EliteTier, EliteDef> = {
  1: { key: 'super', prefix: 'Super', stats: 5, xp: 7, gold: 1, drops: 1, chance: 0.05, color: 0xcd7f32 },
  2: { key: 'mega', prefix: 'Mega', stats: 10, xp: 15, gold: 3, drops: 2, chance: 0.0375, color: 0xd8dde6 },
  3: { key: 'ultra', prefix: 'Ultra', stats: 25, xp: 30, gold: 8, drops: 3, chance: 0.01, color: 0xffcc33 },
};

/** Tempo sem levar ataque até o monstro especial sumir (ms). */
export const ELITE_IDLE_MS = 120_000;

/** Sorteia se o monstro nasce especial (0 = normal). */
export function rollElite(rand: () => number = Math.random): 0 | EliteTier {
  const r = rand();
  if (r < ELITE[3].chance) return 3;
  if (r < ELITE[3].chance + ELITE[2].chance) return 2;
  if (r < ELITE[3].chance + ELITE[2].chance + ELITE[1].chance) return 1;
  return 0;
}
